import React, { useState, useEffect } from "react";
import { getAllContacts } from "../../services/contact-service";
import { useAuth0 } from "@auth0/auth0-react";
import "../../styles/components/contact.css"
import Contact from "./contact";
import Loader from "../navigation/Loader";
import { isUserSiteAdmin, checkUserAffiliationForPermissions } from "../shared/utilities";
import { useStandardQuery } from "../hooks/useStandardQuery";

export default function ContactList({id, showFullVersion = true}) {
    const { getAccessTokenSilently, user } = useAuth0();
    const viewerIsAdmin = isUserSiteAdmin(user);
    var contactsList = useStandardQuery(getAllContacts, null);
    const contactDivs = contactsList?.data?.sort((a,b) => a.firstName.localeCompare(b.firstName)).map(c => 
        <Contact viewerIsAdmin={viewerIsAdmin} contact={c} key={c.id} showFullVersion={false} />
    )

    if(contactsList.status == "error") {
        return (
            <div className="contacts-outer">
            <div className="generic-title">D-backs Family Members & Contacts</div>
            <div className="no-content">You do not have permission to view this content</div>
        </div>
        )
    }

    return (
        <div className="contacts-outer">
            <div className="generic-title">D-backs Family Members & Contacts</div>
            { contactsList.status == "pending" ? <Loader /> :
                <div className="contact-list">
                    {contactDivs}
                </div>
            }
        </div>
    )
}